import { render } from "./PartnerMetrics.vue?vue&type=template&id=aa488d38&scoped=true"
import script from "./PartnerMetrics.vue?vue&type=script&lang=js"
export * from "./PartnerMetrics.vue?vue&type=script&lang=js"

import "./PartnerMetrics.vue?vue&type=style&index=0&id=aa488d38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa488d38"]])

export default __exports__